module.exports = __webpack_public_path__ + "static/media/24UHCHR9.99c22f13.jpg";